import React, { Component } from 'react'
import { withRouter } from 'react-router-dom'
import CacheKeys from '../../../cache/CacheKeys'
import CacheManager from '../../../cache/CacheManager'
import RestApiUtils from '../../../apiclient/moebli/RestApiUtils'
import BankAnalyzerUI from './BankAnalyzerUI'

class BankAnalyzerSF extends Component {
  constructor(props) {
    super(props)
    this.state = {
      successMsg: null,
      errorList: null,
      bankAnalyzerSubmitted: false,
      showKeywords: false
    }
  }

  render() {
    return (
      <BankAnalyzerUI
        context={this.props.context}
        account={this.props.account}
        show={this.props.show}
        errorList={this.state.errorList}
        successMsg={this.state.successMsg}
        onRefreshClick={this.props.onRefreshClick}
        //
        onBankAnalyzerSubmit={this.onBankAnalyzerSubmit}
        bankAnalyzerSubmitted={this.state.bankAnalyzerSubmitted}
        showKeywords={this.state.showKeywords}
        onKeywordsClick={() => {this.setState({showKeywords: !this.state.showKeywords})}}
        //
        propertyValue={this.state.propertyValue}
      />
    )
  }

  componentDidMount() {
    let context = this.props.context
    this.getFreezeBankAnalyzer(context)
  }

  getFreezeBankAnalyzer(context) {
    let cacheManager = new CacheManager({
      resource: `/api/su/accounts/${this.props.match.params.accountId}/properties/freeze_bank_analyzer`,
      cacheKey: CacheKeys.FreezeBankAnalyzer(this.props.match.params.accountId),
      callback: this.getFreezeBankAnalyzerCallback,
      ttlInSecs: 600
    })
    cacheManager.getObject2(context)
  }

  getFreezeBankAnalyzerCallback = (response) => {
    this.setState({
      errorList: response.errorList,
      propertyValue: response.propertyValue
    })
  }

  onBankAnalyzerSubmit = () => {
    let submitted = this.state.bankAnalyzerSubmitted
    if (submitted)
      return

    this.setState({
      successMsg: null,
      errorList: [],
      bankAnalyzerSubmitted: true
    })

    RestApiUtils.put(this.props.context,
      `/api/su/accounts/${this.props.match.params.accountId}/clientTransactions/categories/analyzer`,
      this.onBankAnalyzerCallback, {}
    )
  }

  onBankAnalyzerCallback = (response) => {
    let errorList = []
    response.errorList.forEach(error => {
      errorList.push(error.message)
    })

    this.setState({
      successMsg: response.success,
      errorList: errorList,
      bankAnalyzerSubmitted: false
    })

    setTimeout(() => {
      this.setState({ successMsg: null })
    }, 2000)

    if (response.errorList.length === 0) {
      this.props.onRefreshClick('noBusy')
    }
  }
}

export default withRouter(BankAnalyzerSF)
